// Controls document.title across the app.
//
// Private/admin areas keep a generic title so internal module names
// (Dashboard, Reservas, Pagamentos, Admin, ...) never leak through the tab.
// Public pages may expose their real, translated title for multilingual SEO,
// which SEOHead sets through setAllowedTitle().

const GENERIC_TITLE = "Berastays.com/App";

let installed = false;
let allowedTitle = GENERIC_TITLE;

const apply = () => {
  try {
    let titleEl = document.querySelector("title");
    if (!titleEl) {
      titleEl = document.createElement("title");
      document.head.appendChild(titleEl);
    }
    if (titleEl.textContent !== allowedTitle) {
      titleEl.textContent = allowedTitle;
    }
  } catch {
    /* noop */
  }
};

/** Sets the title the app is allowed to display (used by SEOHead). */
export function setAllowedTitle(title?: string) {
  allowedTitle = title && title.trim() ? title.trim() : GENERIC_TITLE;
  apply();
}

export function lockDocumentTitle() {
  if (installed || typeof document === "undefined") return;
  installed = true;

  apply();

  // Trap raw document.title assignments — only the allowed title is rendered.
  try {
    Object.defineProperty(Document.prototype, "title", {
      configurable: true,
      get() {
        return allowedTitle;
      },
      set(_value: string) {
        apply();
      },
    });
  } catch {
    /* some browsers may forbid redefining built-ins — observer below covers it */
  }

  // Defensive: watch the <head> for any <title> changes and reset.
  try {
    const head = document.head;
    if (head && typeof MutationObserver !== "undefined") {
      const observer = new MutationObserver(() => apply());
      observer.observe(head, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  } catch {
    /* noop */
  }
}
